(function () {
  const initMainNav = () => {
    if (MegaMenu) {
      const menu = new MegaMenu(".siteheader-nav", {
        navActiveClass: "navlink-active",
        subnavActiveClass: "subnav-active",
      });
    }
  };
  const initHomeCarousel = () => {
    if (window.Swiper) {
      const swiper1 = new window.Swiper(".hero-swiper", {
        loop: true,
        speed: 1000,
        slidesPerView: 1.0001,
        centeredSlides: true,
        parallax: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-btn-next",
          prevEl: ".swiper-btn-prev",
        },

        observer: true,
        observeParents: true,
      });
    }
  };
  const initStudentCarousel = () => {
    if (window.Swiper) {
      const swiper2 = new window.Swiper(".student-swiper", {
        loop: true,
        speed: 900,
        slidesPerView: 1.0001,
        spaceBetween: 24,
        // centeredSlides: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          760: {
            slidesPerView: 2.0002,
          },
          1272: {
            slidesPerView: 3.0003,
          },
        },
        navigation: {
          nextEl: ".swiper-btn-next",
          prevEl: ".swiper-btn-prev",
        },
        observer: true,
        observeParents: true,
      });
    }
  };
  const initContactForm = () => {
    const form = document.querySelector("#contactusForm");

    form &&
      FormValidator &&
      new FormValidator(form, {
        messages: {
          email: "Please enter a valid email address",
        },
        customValidators: {
          // password(value) {
          //   if (value.length < 8) {
          //     return 'Password must be at least 8 characters';
          //   }
          //   return true;
          // },
        },
        async onSubmit(thisform) {
          const form = thisform;
          const result = document.getElementById("contactus_msg");
          const btn = form.querySelector('button[type="submit"]');

          btn.disabled = true;
          btn.querySelector("span#send_cta_text").textContent = "Sending…";
          result.classList.add("d-none");
          result.classList.remove("d-block");
          result.classList.remove("alert-danger");
          result.classList.remove("alert-success");
          result.querySelector("#contactus_msg_text").textContent = "";

          try {
            const res = await fetch("/contact/send.php", {
              method: "POST",
              body: new FormData(form),
            });
            if (!res.ok) {
              throw new Error(`Server error: ${res.status}`); // jumps straight to catch
            }
            const data = await res.json();
            if (data?.success) {
              result.classList.remove("d-none");
              result.classList.add("d-block");
              result.classList.add("alert-success");
              result.querySelector("#contactus_msg_text").textContent =
                "Message was sent successfully!!!";
              form.reset();
            } else {
              throw new Error(`Server error: ${res.status}`); // jumps straight to catch
            }
          } catch {
            result.classList.remove("d-none");
            result.classList.add("d-block");
            result.classList.add("alert-danger");
            result.querySelector("#contactus_msg_text").textContent =
              "Something went wrong. Please try again.";
          } finally {
            btn.disabled = false;
            btn.querySelector("span#send_cta_text").textContent =
              "Send Message";
          }
        },
      });
  };

  const initThemeSwitcher = () => {
    const STORAGE_KEY = 'kh-theme';
    const switcher = document.getElementById('theme_selector');
    let currentTheme = localStorage.getItem(STORAGE_KEY) || 'light';
    localStorage.setItem(STORAGE_KEY, currentTheme);
    document.querySelector('html').setAttribute('data-bs-theme', currentTheme);
    if (currentTheme === 'dark') {
      switcher.checked = true;
    }
    switcher.addEventListener("change", () => {
      currentTheme = switcher.checked ? 'dark' : 'light';
      localStorage.setItem(STORAGE_KEY, currentTheme);
      document.querySelector('html').setAttribute('data-bs-theme', currentTheme);
    });
  };

  function init() {
    // const isModalShown = sessionStorage.getItem("siteuc_modal_shown");
    // if (!isModalShown) {
    //   const siteucModal = document.getElementById("siteuc_modal");
    //   const modal = new bootstrap.Modal(siteucModal);
    //   modal.show();
    //   sessionStorage.setItem("siteuc_modal_shown", "true");
    // }

    initThemeSwitcher();
    initMainNav();
    initHomeCarousel();
    initStudentCarousel();
    initContactForm();
  }

  if (document.readyState !== "loading") {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }
})();
